import {
  SingleProviderConfig,
  ShopType,
  CheckoutType,
  CrossSellType,
} from 'types';
import { allLeadMode, getDefaultCrossSellAction } from 'config';
import {
  Comcast,
  Cox,
  Spectrum,
  Mediacom,
  Optimum,
  WOW,
} from 'config/providers';
import { SpectrumTheme } from 'config/themes';
import { spectrumRedirectUrl } from 'config/redirectUrls';

export const SpectrumSpecial: SingleProviderConfig = {
  name: 'SpectrumSpecial',
  micrositeCode: 'spectrum',
  mainProvider: Spectrum,
  shopType: ShopType.SINGLE_PROVIDER,
  domain: 'spectrumspecial.com',
  homepage: 'https://spectrumspecial.com',
  title: 'Spectrum Authorized Dealer',
  fallbackPhoneNumber: '866-282-1155',
  fallbackLeadModePhoneNumber: '866-428-6055',
  defaultCheckoutType: CheckoutType.PROVIDER_REDIRECT,
  activeServiceCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: SpectrumTheme,
  needsDcSession: false,
  source: 'Spectrum',
  noOffersRetry: 2,
  getCrossSellAction: getDefaultCrossSellAction,
  getCheckoutType: allLeadMode,
  crossSellProviders: [Comcast, Cox, Optimum, Mediacom, WOW],
  updaterCrossSellActive: false,
  getProviderRedirectUrl: spectrumRedirectUrl,
  redirectWhenUnavailable: true,
};
